import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';

import FavouriteView from 'views/Favourite';
import ListPhoneNumbersService from 'api/ListPhoneNumbers';
import MediaAudioService from 'api/MediaAudio';
import { useDelete, useFetchTableData } from 'hooks';
import SettingsActions from 'store/reducers/Settings';

const Favourite = ( { parentPath, toggleLoading, toggleErrorAlert } ) => {
  const [phoneSubmitted, setPhoneSubmitted] = useState( new Date().valueOf() );
  const [audioSubmitted, setAudioSubmitted] = useState( new Date().valueOf() );

  const [fetchPhones, phones, phonesLoading] = useFetchTableData( {
    promise: ListPhoneNumbersService.getListPhoneNumbers,
    toggleErrorAlert,
    deps: [phoneSubmitted],
  } );

  const [fetchAudios, audios, audiosLoading] = useFetchTableData( {
    promise: MediaAudioService.getMediaAudios,
    toggleErrorAlert,
    deps: [audioSubmitted],
  } );

  const reloadPhones = useCallback( () => {
    setPhoneSubmitted( new Date().valueOf() );
  }, [] );

  const reloadAudios = useCallback( () => {
    setAudioSubmitted( new Date().valueOf() );
  }, [] );

  const deletePhone = useDelete( {
    promise: ListPhoneNumbersService.deleteListPhoneNumbers,
    callback: reloadPhones,
    toggleLoading,
    toggleErrorAlert,
  } );

  const deleteAudio = useDelete( {
    promise: MediaAudioService.deleteMediaAudio,
    callback: reloadAudios,
    toggleLoading,
    toggleErrorAlert,
  } );

  return (
    <FavouriteView
      phones={phones}
      audios={audios}
      parentPath={parentPath}
      phonesLoading={phonesLoading}
      audiosLoading={audiosLoading}
      onFetchPhones={fetchPhones}
      onFetchAudios={fetchAudios}
      onDeletePhone={deletePhone}
      onDeleteAudio={deleteAudio}
      onReloadAudios={reloadAudios}
      onReloadPhones={reloadPhones}
    />
  );
};

const mapDispatchToProps = ( {
  toggleErrorAlert: SettingsActions.toggleErrorAlert,
  toggleLoading: SettingsActions.toggleLoading,
} );

export default connect( null, mapDispatchToProps )( Favourite );
